[
    {
        "key": "1",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 4,
                "y": 9,
                "key": "xMSu7"
            },
            {
                "x": 2,
                "y": 9,
                "key": "4St2N"
            },
            {
                "x": 1,
                "y": 9,
                "key": "i1otH"
            },
            {
                "x": 1,
                "y": 8,
                "key": "RBCT-"
            },
            {
                "x": 1,
                "y": 7,
                "key": "6zmsi"
            },
            {
                "x": 1,
                "y": 7,
                "key": "UmGU9e9DGAW2cgtDM5LDE"
            },
            {
                "x": 5,
                "y": 7,
                "key": "Y_QtY"
            },
            {
                "x": 7,
                "y": 7,
                "key": "87Arv"
            },
            {
                "x": 11,
                "y": 7,
                "key": "m0tm9EaEvdCqJFffxHmqg"
            },
            {
                "x": 12,
                "y": 7,
                "key": "NjyBq"
            },
            {
                "x": 12,
                "y": 9,
                "key": "fSGPv"
            },
            {
                "x": 11,
                "y": 9,
                "key": "yISFx"
            },
            {
                "x": 11,
                "y": 9,
                "key": "VjHMM"
            },
            {
                "x": 9,
                "y": 9,
                "key": "U2EqybwO2xGhP4bxOgYGF"
            },
            {
                "x": 9,
                "y": 9,
                "key": "SNZ-8"
            },
            {
                "x": 6,
                "y": 9,
                "key": "tgAlOo15-hexJ72EDJs-g"
            }
        ]
    }
]